class ClientAdminUserCtrl {
    constructor(CONTENT_TYPE, $apiService, $uibModal, Notification, $userService, $rootScope) {

        this.users = [];
        this.client = {};

        this.CONTENT_TYPE = CONTENT_TYPE;
        this.$apiService = $apiService;
        this.$uibModal = $uibModal;
        this.Notification = Notification;
        this.$userService = $userService;
        this.$rootScope = $rootScope;

        $apiService.getCurrent(CONTENT_TYPE.CLIENT)
            .then(response => {
                this.client = response.data;
                this.loadUsers();
            });
    }

    loadUsers() {
        this.loading = true;
        this.$apiService.list(this.CONTENT_TYPE.CLIENTADMIN, '')
            .then(response => {
                this.users = response.data;
                this.loading = false;
            });

    }

    addUser() {
        var modalInstance = this.$uibModal.open({
            animation: true,
            templateUrl: 'admin/add-user.html',
            controller: 'AddUserCtrl',
            resolve: {
                rootFolder: () => this.client.rootFolder,
            }
        });
        modalInstance.result.then((newItem) => {
            this.createUser(newItem);
        });
    }

    createUser(user) {
        user.securityRoles = user.securityRoles.join(',');
        this.$apiService.create(this.CONTENT_TYPE.CLIENTADMIN, user)
            .then(response => {
                this.$rootScope.$emit(this.EVENTS.SHOW_NOTIFICATION, {'message': "User created."});
                this.loadUsers();
            }, error => {
                console.error(error);
            });
    }
    
    updateUser(user) {
        console.log(user);
        var modalInstance = this.$uibModal.open({
            animation: true,
            templateUrl: 'admin/edit-user.html',
            controller: 'AddUserCtrl',
            resolve: {
                rootFolder: () => this.client.rootFolder,
                user: user
            }
        });
        modalInstance.result.then((newItem) => {
            this.updateUserRecord(newItem);
        }, () => {

        });
    }
    
    deleteUser(user) {
        var modalInstance = this.$uibModal.open({
            animation: true,
            templateUrl: 'delete-confirm.html',
            controller: 'DeleteConfirmationCtrl'
        });

        modalInstance.result.then(() => {
            this.$apiService.delete(this.CONTENT_TYPE.CLIENTADMIN, user.id)
                .then((response) => {
                    this.$rootScope.$emit(this.EVENTS.SHOW_NOTIFICATION, {'message': "Deleted user."});
                    this.loadUsers();
                }, (response) => {
                    console.error(response);
                    console.error(response);
                });
        },() => {
            // NOOP
        });
    }
    
    updateUserRecord(user) {
        user.securityRoles = user.securityRoles.join(',');
        this.$apiService.update(this.CONTENT_TYPE.CLIENTADMIN, user)
            .then(response => {
                this.$rootScope.$emit(this.EVENTS.SHOW_NOTIFICATION, {'message': "User updated."});
                this.Notification.success('User updated.');
                this.loadUsers();
            }, error => {
                console.error(error);
            });
    }
    
    changePassword(user) {
        var modalInstance = this.$uibModal.open({
            animation: true,
            templateUrl: 'admin/change-password.html',
            controller: 'AddItemCtrl'
        });

        modalInstance.result.then((newItem) => {
            this.$userService.changePassword(this.CONTENT_TYPE.CLIENTADMIN, user.id, newItem.password)
                .then((response) => {
                    this.Notification.success('Password updated.');
                    this.$rootScope.$emit(this.EVENTS.SHOW_NOTIFICATION, {'message': "Password updated."});
                    this.loadUsers();
                }, (response) => {
                    console.error(response);
                    console.error(response);
                });
        },() => {
            // NOOP
        });
    }

    updatePermissions(user) {
        var modalInstance = this.$uibModal.open({
            animation: true,
            templateUrl: 'admin/edit-permissions.html',
            controller: 'SetPermissionsCtrl',
            resolve: {
                user: user
            }
        });

        modalInstance.result.then((permissions) => {
            this.$userService.setPermissions(this.CONTENT_TYPE.CLIENTADMIN, user.id, permissions)
                .then((response) => {
                    this.$rootScope.$emit(this.EVENTS.SHOW_NOTIFICATION, {'message': "Permission updated."});
                    this.loadUsers();
                }, (response) => {
                    console.error(response);
                    console.error(response);
                });
        });
    }
    
    getClientName(id) {
        let client = this.clients.filter(c => c.id === id);
        return (client.length > 0 && client[0].hasOwnProperty('name'))
            ? client[0].name
            : 'NO CLIENT';
    }
}

angular.module('cpm')
    .controller('ClientAdminUserCtrl', ['CONTENT_TYPE', 'ApiService', '$uibModal', 'Notification', 'UserService', '$rootScope', ClientAdminUserCtrl]);
